import React from 'react';
import { Text, Stack, Image, ImageFit } from '@fluentui/react';
import { useSelector, useDispatch } from "react-redux";
import Type from "../../Redux/Type";
import { CommandButton } from "../Accessary";
import { onOpenRightPanel, onCloseRightPanel } from "../../Containers/RightPanelAction";
import URL from "../../Containers/MainController";


const Menu = () => {
    const userInfoEnter = useSelector(state => state.UserInfoEnter);
    const dispatch = useDispatch();

    const onButtonPress = (route) => () => onOpenRightPanel(route)
    const onDrawingPress = () => {
        dispatch({ type: Type.SHOW_ON_DRAWING });
        dispatch({ type: Type.START_DRAWING })
        onCloseRightPanel()
    }
    return (
        <div className='modal-content-container'>
            <div className='animated-panel'>
                <Text variant='xLarge' className='title'>Menu</Text>

                <Stack tokens={{ childrenGap: 10 }}>
                    {
                        userInfoEnter && userInfoEnter.APILink ?
                            <CommandButton
                                title='Vẽ quy hoạch'
                                iconName='EditCreate'
                                onClick={onDrawingPress}
                            />
                            : null
                    }
                    <CommandButton
                        title='Tìm kiếm'
                        iconName='search'
                        onClick={onButtonPress('search')}
                    />

                    <CommandButton
                        title='Quy hoạch'
                        iconName='MapLayers'
                        onClick={onButtonPress('layer')}
                    />

                    <CommandButton
                        title='Chế độ xem'
                        iconName='Nav2DMapView'
                        onClick={onButtonPress('satellite')}
                    />

                    <CommandButton
                        title='Chuyển vị trí'
                        iconName='MapPin'
                        onClick={onButtonPress('locationEnter')}
                    />

                    {/* <CommandButton
                        title='Chuyển server'
                        iconName='ServerProcesses'
                        onClick={onButtonPress('server')}
                    /> */}

                    {
                        userInfoEnter ?

                            <CommandButton
                                title={'Tài khoản'}
                                iconName='ContactCard'
                                onClick={onButtonPress('account')}
                            />
                            :
                            <CommandButton
                                title='Đăng nhập'
                                iconName='Contact'
                                onClick={onButtonPress('login')}
                            />

                    }


                    <Stack style={styles.inline} />
                    <Text style={{ textAlign: 'center', color: 'gray' }}>Tải ứng dụng VNPT-ILIS để có trải nghiệm tốt hơn trên thiết bị di động.</Text>
                    <Stack style={{ flexDirection: 'row', marginTop: 10, justifyContent: 'center' }}>
                        <a href={URL.urlDownloadIOS}>
                            <Image
                                src={require("../../Assets/DownIOS.png")}
                                imageFit={ImageFit.contain}
                                width={100}
                                height={40}
                            />
                        </a>
                        <Stack style={{ width: 30 }} />
                        <a href={URL.urlDownloadAndroid}>
                            <Image
                                src={require("../../Assets/DownAndroid.png")}
                                imageFit={ImageFit.contain}
                                width={100}
                                height={40}
                            />
                        </a>
                    </Stack>

                </Stack>
            </div>
        </div>
    )
}

export default Menu;

const styles = {
    inline: {
        height: 1,
        backgroundColor: '#BDBDBD',
        width: '100%',
        marginTop: 30,
        marginBottom: 20
    }
};

